import React, { useCallback } from "react"

import Autoplay from "embla-carousel-autoplay"
import useEmblaCarousel from "embla-carousel-react"
import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"

import autoplay from "./autoplay"
import * as styles from "./carousel.module.scss"
import Button from "../../atoms/button"
import CopyContainer from "../../atoms/copy-container"
import Icon from "../../atoms/icon"
import ButtonGroup from "../button-group"

const Carousel = ({ data, autoscroll, timer }) => {
  const { allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)

  const [emblaRef, emblaApi] = useEmblaCarousel({}, [
    Autoplay({ playOnInit: autoscroll, delay: timer }),
  ])

  const { onAutoplayButtonClick } = autoplay(emblaApi)

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollPrev()
  }, [emblaApi])

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollNext()
  }, [emblaApi])

  return (
    <div className={styles.wrapper} ref={emblaRef}>
      <div className={styles.container}>
        {data.map((slide) => (
          <div className={`${styles.slide} ${styles[`${slide.custom_class}`]}`}>
            <div
              className={`${slide.border ? styles.content__border : ""} ${
                slide.border && slide.color
                  ? styles[`content__${slide.color.replace("-", "")}`]
                  : ""
              } ${styles[`content__${slide.alignment}`]}`}
            >
              <CopyContainer content={slide._rawContent} />
              {slide.ctas.length > 0 ? (
                <ButtonGroup ctas={slide.ctas} alignment={slide.alignment} />
              ) : (
                ""
              )}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.controls}>
        <div className={styles.buttons}>
          <Button
            variant="secondary"
            pressEvent={() => onAutoplayButtonClick(onPrevButtonClick)}
          >
            <Icon icon="arrow_left" />{" "}
            {
              allSanityDictionary.nodes.find(
                (item) => item.key.current === "previous"
              )?.value
            }
          </Button>
          <Button
            variant="secondary"
            pressEvent={() => onAutoplayButtonClick(onNextButtonClick)}
          >
            {
              allSanityDictionary.nodes.find(
                (item) => item.key.current === "next"
              )?.value
            }{" "}
            <Icon icon="arrow_right" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Carousel

Carousel.propTypes = {
  data: PropTypes.array.isRequired,
  autoscroll: PropTypes.bool,
  timer: PropTypes.number,
}

Carousel.defaultProps = {
  autoscroll: false,
  timer: 5000,
}
